import React from "react";
import { SignInButton } from "@clerk/clerk-react";
import { useTheme } from "next-themes";

export default function Landing() {
    const { theme, setTheme } = useTheme();
    const isDark = theme === "dark";

    return (
        <div className="w-full max-w-4xl">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
                {/* Header */}
                <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 dark:from-emerald-600 dark:to-emerald-700 px-8 py-12 text-center relative">
                    <button
                        onClick={() => setTheme(isDark ? "light" : "dark")}
                        className="absolute top-4 right-4 p-2 rounded-lg bg-white bg-opacity-20 hover:bg-opacity-30 transition-colors"
                        title={
                            isDark ? "Ativar modo claro" : "Ativar modo escuro"
                        }
                    >
                        {isDark ? (
                            <svg
                                className="w-5 h-5 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                                />
                            </svg>
                        ) : (
                            <svg
                                className="w-5 h-5 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                                />
                            </svg>
                        )}
                    </button>

                    <div className="flex justify-center mb-6">
                        <div className="p-4 bg-white bg-opacity-20 rounded-2xl">
                            <svg
                                className="w-12 h-12 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M15 14h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                        </div>
                    </div>
                    <h1 className="text-4xl font-bold text-white mb-4">
                        BarberBot
                    </h1>
                    <p className="text-xl text-emerald-100 max-w-2xl mx-auto">
                        Sistema completo de gestão para barbearias com
                        atendimento automático via WhatsApp
                    </p>
                </div>

                {/* Content */}
                <div className="px-8 py-12">
                    <div className="grid md:grid-cols-2 gap-8 mb-10">
                        <div>
                            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                                Automatize seu atendimento
                            </h2>
                            <p className="text-gray-600 dark:text-gray-300 mb-6">
                                Um assistente inteligente que atende seus
                                clientes 24/7 pelo WhatsApp, gerencia
                                agendamentos e mantém você sempre informado
                                sobre sua barbearia.
                            </p>
                            <div className="space-y-3">
                                <div className="flex items-center gap-3">
                                    <div className="p-1 bg-emerald-100 dark:bg-emerald-900 rounded-full">
                                        <svg
                                            className="w-4 h-4 text-emerald-600 dark:text-emerald-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 dark:text-gray-300">
                                        Agendamentos automáticos via WhatsApp
                                    </span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="p-1 bg-emerald-100 dark:bg-emerald-900 rounded-full">
                                        <svg
                                            className="w-4 h-4 text-emerald-600 dark:text-emerald-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 dark:text-gray-300">
                                        Gestão completa de clientes
                                    </span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="p-1 bg-emerald-100 dark:bg-emerald-900 rounded-full">
                                        <svg
                                            className="w-4 h-4 text-emerald-600 dark:text-emerald-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 dark:text-gray-300">
                                        Painel de controle intuitivo
                                    </span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="p-1 bg-emerald-100 dark:bg-emerald-900 rounded-full">
                                        <svg
                                            className="w-4 h-4 text-emerald-600 dark:text-emerald-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                    </div>
                                    <span className="text-gray-700 dark:text-gray-300">
                                        Histórico de atendimentos
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-50 dark:bg-gray-700 rounded-xl p-6">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                Funcionalidades principais
                            </h3>
                            <div className="space-y-4">
                                <div className="flex items-start gap-3">
                                    <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg flex-shrink-0">
                                        <svg
                                            className="w-5 h-5 text-blue-600 dark:text-blue-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-900 dark:text-white">
                                            Agenda Inteligente
                                        </h4>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Visualize todos os agendamentos por
                                            barbeiro e data
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-3">
                                    <div className="p-2 bg-emerald-100 dark:bg-emerald-900 rounded-lg flex-shrink-0">
                                        <svg
                                            className="w-5 h-5 text-emerald-600 dark:text-emerald-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-900 dark:text-white">
                                            Chat Automatizado
                                        </h4>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Bot responde automaticamente no
                                            WhatsApp
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-3">
                                    <div className="p-2 bg-purple-100 dark:bg-purple-900 rounded-lg flex-shrink-0">
                                        <svg
                                            className="w-5 h-5 text-purple-600 dark:text-purple-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-900 dark:text-white">
                                            Gestão de Clientes
                                        </h4>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Cadastro completo com histórico de
                                            atendimentos
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <SignInButton>
                            <button className="px-8 py-4 bg-emerald-500 text-white rounded-xl font-semibold text-lg hover:bg-emerald-600 transition-colors shadow-lg hover:shadow-xl flex items-center gap-3 mx-auto">
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                                    />
                                </svg>
                                Começar agora - É grátis
                            </button>
                        </SignInButton>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
                            Configure sua barbearia em menos de 5 minutos
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
